<template>
  <div style="padding-top: 40px">
<!--    <div v-if="infoIzbranegaPrikljucka.tip_prikljucka === 'FIX'">
      <p v-if="infoPripisObPaketu === true" class="navadno-besedilo">
        Vaš paket je del ponudbe, ki ni več na voljo.
        Preverite naše novejše pakete s hitrejšimi internetnimi povezavami, z napredno T-2 televizijo in odličnimi
        mobilnimi paketi. Izberite tistega, ki najbolj ustreza vašim željam in potrebam.
      </p>
      <p v-if="!infoPripisObPaketu" class="navadno-besedilo">
        Preverite pestro ponudbo ugodnih T-2 paketov, ki zagotavljajo kakovostne storitve interneta, televizije
        ter mobilne in stacionarne telefonije. <br>
        Izberite tistega, ki najbolj ustreza vašim željam in potrebam.
      </p>
    </div>
    <div v-else>
      <p class="navadno-besedilo">
        Izberite svoj paket in uživajte ob najljubših TV vsebinah.
      </p>
    </div>-->
    <div class="navadno-besedilo" v-if="infoIzbranegaPrikljucka.tip_prikljucka === 'FIX'">
      Na tej strani lahko preverite vaš naročen paket in izberete morebitne nadgradnje paketa.
      <br/>V primeru, da želite zamenjati svoj paket, lahko naročilo oddate s klicem na številko 064 064 064,
      poslanim sporočilom na
      <a href="" class="primarna-barva" v-if="kontaktniPodatki !== null">
        {{ kontaktniPodatki.T2_INFO_EMAIL }}
      </a>
      ali obiščite
      <span class="primarna-barva">
        najbližjo T-2 poslovalnico.
      </span>
      <br/>
      Ponudbo tržnih paketov boste našli na
      <span class="primarna-barva">
              T-2 spletni strani.
      </span>
    </div>
    <div class="postavitev-paketa">
      <div
        v-for="paket in seznamPaketov"
        class="postavitev-podatkov-paketa"
        :data-tabkey="tabKey">
        <div class="postavitev-naziva">
          <b>
            {{ paket.naziv.toUpperCase() }}
          </b>
        </div>
        <div class="podcrtan-naziv">
        </div>
        <div class="tp-opis oblika-opisa levo-brez-odmika" v-html="paket.opis" style="font-size: 14px;"></div>
        <div class="tp-hitrost" v-if="infoIzbranegaPrikljucka.tip_prikljucka !== 'OTT'">
          <div class="hr-stil-container" style="padding-bottom: 20px">
            <hr class="hr-stil">
          </div>
          <div style="margin-bottom: 15px">
            <b>
              Izbira internetne hitrosti
            </b>
          </div>
          <div v-if="obstojIzbireHitrostiPriTrznihPaketih[paket.idStoritevVrstaIzbira] === true">
            <div v-for="hitrost in paket.hitrosti">
              <el-radio-group v-model="izbranaHitrostPaketNova[paket.idStoritevVrstaIzbira]"
                              v-if="(hitrost.prikazServisne !== 0 ||
                              izbranaHitrostPaket[paket.idStoritevVrstaIzbira] === hitrost.idStoritevVrstaIzbira + '_' + paket.idStoritevVrstaIzbira) && paket.dovoljenaIzbira"
                              :disabled="narociloVTeku"
              >
                <el-radio class="tp-hitrost-izbira"
                          :label="hitrost.idStoritevVrstaIzbira + '_' + paket.idStoritevVrstaIzbira"
                          @change="PosodobiPotencialnoNarocilo(paket.idStoritevVrstaIzbira, hitrost.idStoritevVrstaIzbira)"
                          :data-tabkey="tabKey + '_' + hitrost.idStoritevVrstaIzbira + '_' + paket.idStoritevVrstaIzbira"
                          :disabled="narociloVTeku"
                >
                  <span style="display: inline-table; line-height: 1.7em">
                    {{ hitrost.naziv }}
                    <br v-if="hitrost.cenaSI !== prepovedanPrikazZneska"/>
                    <span v-if="hitrost.cenaSI !== prepovedanPrikazZneska" style="display:inline-block">
                      (doplačilo {{ hitrost.cenaSI + ' €' }})
                    </span>
                  </span>
                </el-radio>
              </el-radio-group>
            </div>
          </div>
          <div v-else style="text-align: center">
            <em>
              <span style="font-size: 12px;">
                Nadgradnje hitrosti niso na voljo
              </span>
            </em>
          </div>
        </div>
        <div class="tp-ugodnost" v-if="infoIzbranegaPrikljucka.tip_prikljucka !== 'OTT' && paket.ugodnosti !== undefined && paket.ugodnosti.length > 0">
          <div class="hr-stil-container" style="padding-bottom: 20px">
            <hr class="hr-stil">
          </div>
          <div style="margin-bottom: 15px">
            <b>
              <span>Izbira zvestobe</span>
            </b>
          </div>
          <div v-if="obstojIzbireUgodnostiPriTrznihPaketih[paket.idStoritevVrstaIzbira] === true">
            <div v-for="ugodnost in paket.ugodnosti" class="ugodnosti-izbira">
              <el-checkbox v-if="izbranaUgodnostPaket[ugodnost.idStoritevVrstaIzbira + '_' + paket.idStoritevVrstaIzbira] === true && (paket.vklopljeno === 1 || paket.naroceno === 1) && paket.dovoljenaIzbira === 1"
                           v-model="izbranaUgodnostPaketNova[ugodnost.idStoritevVrstaIzbira + '_' + paket.idStoritevVrstaIzbira]"
                           :label="ugodnost.idStoritevVrstaIzbira + '_' + paket.idStoritevVrstaIzbira"
                           @change="OdstraniOstaleIzbireUgodnosti(ugodnost.idStoritevVrstaIzbira + '_' + paket.idStoritevVrstaIzbira)"
                           disabled
              >
                {{ugodnost.naziv}}
              </el-checkbox>
              <el-checkbox v-else-if="paket.dovoljenaIzbira === 1"
                           v-model="izbranaUgodnostPaketNova[ugodnost.idStoritevVrstaIzbira + '_' + paket.idStoritevVrstaIzbira]"
                           :label="ugodnost.idStoritevVrstaIzbira + '_' + paket.idStoritevVrstaIzbira"
                           @change="OdstraniOstaleIzbireUgodnosti(ugodnost.idStoritevVrstaIzbira + '_' + paket.idStoritevVrstaIzbira)"
                           :disabled="narociloVTeku"
              >
                {{ugodnost.naziv}}
              </el-checkbox>
            </div>
          </div>
          <div v-else style="text-align: center">
            <em>
              <span style="font-size: 12px;">
                Izbira zvestobe ni na voljo.
              </span>
            </em>
          </div>
        </div>
        <div class="tp-spodnji-del">
          <div class="izpis-cena-trzni-paket"
               v-if="typeof paket.cenaSI !== 'undefined' && paket.cenaSI !== null && paket.cenaSI.length > 0">
            <span :class="paket.dovoljenaIzbira === 1 ? '' : 'besedilo-nedovoljena-izbira'">
              {{ GetPreracunanaCena(paket) }} € / mesec
            </span>
            <br/>
          </div>
          <div v-if="paket.dovoljenaIzbira === 1" class="gumb-narocanje-trzni-paket" style="clear: both">
            <div v-if="StaSeznamUgodnostiEnaka() === true
                      && izbranaHitrostPaketNova[paket.idStoritevVrstaIzbira] === izbranaHitrostPaket[paket.idStoritevVrstaIzbira]
                      && paket.vklopljeno === 1"
                class="gumb-naroceno-vmesni-div">
              <a class="okvir-naroceno izpis-stanja">
                <img src="/static/img/kljukica2.svg" width="12px" style="vertical-align: middle; margin-right: 8px;" />
                <b>
                  VKLOPLJENO
                </b>
              </a>
            </div>
          </div>
          <OrderButton
            :custom-notify-text="'Ste prepričani, da želite ' + spremniText + '?'"
            v-if="GetServices(paket).length > 0 || !StaSeznamUgodnostiEnaka()"
            :services="GetServices(paket)"
            style="width: 178px; margin: 0 auto;"
            :service-name="'storitev znotraj naročenega paketa'"
            @orderConfirmed="$emit('orderConfirmed')"
            :disabled="narociloVTeku"
          >
             SPREMENI PAKET
          </OrderButton>
          <div v-else-if="izbranaHitrostPaketNova[paket.idStoritevVrstaIzbira] !== izbranaHitrostPaket[paket.idStoritevVrstaIzbira]"
               class="gumb-narocanje-trzni-paket"
               style="clear: both">
            <div class="gumb-naroceno-vmesni-div">
              <a class="okvir-naroceno izpis-stanja">
                <img src="/static/img/kljukica2.svg" width="12px" style="vertical-align: middle; margin-right: 8px;" />
                <b>
                  VKLOPLJENO
                </b>
              </a>
            </div>
          </div>
<!--          <div v-if="paket.dovoljenaIzbira === 1 &&
              ((paket.naroceno === 0 && paket.vklopljeno !== 1) ||
              (StaSeznamUgodnostiEnaka() === false ||
              izbranaHitrostPaketNova[paket.idStoritevVrstaIzbira] !== izbranaHitrostPaket[paket.idStoritevVrstaIzbira]))">
            <el-button type="primary" class="gumb-potrdi gumb-narocanje-trzni-paket" style="margin: 0 auto;"
                       v-on:click="PrikazPogodbe(paket)">
              NAROČI PAKET
            </el-button>
          </div>-->
<!--          <div v-if="paket.dovoljenaIzbira === 1 && paket.naroceno === 1 && paket.vklopljeno !== 1 &&
                  StaSeznamUgodnostiEnaka() === true &&
                  izbranaHitrostPaketNova[paket.idStoritevVrstaIzbira] === izbranaHitrostPaket[paket.idStoritevVrstaIzbira]"
               style="margin: 0 auto;">
            <a class="okvir-narocilo-v-teku izpis-stanja">
              <b>
                NAROČENO
              </b>
            </a>
          </div>-->
<!--          <div v-if="paket.dovoljenaIzbira !== 1" style="margin: 0 auto;">
            <a class="okvir-narocilo-v-teku izpis-stanja gumb-ni-na-voljo sirina-gumba-ni-na-voljo">
              <b>
                NI NA VOLJO
              </b>
            </a>
          </div>-->
        </div>
      </div>
<!--      <div v-if="infoPripisObPaketu === true && seznamPaketov.length > 0" class="infokomponenta-stari-paket sirok">
        <InfoKomponenta/>
      </div>-->
    </div>
<!--    <div>
      <InfoKomponenta v-if="infoPripisObPaketu === false && seznamPaketov.length > 0"/>
    </div>-->
    <order-exists-info v-if="narociloVTeku"/>
  </div>
</template>
<script>
import Vue from 'vue'
import {Select, Option, Form, Button, Checkbox, CheckboxGroup, Collapse, CollapseItem, Col, Tabs, TabPane} from 'element-ui'
import InfoKomponenta from './InfoKomponenta'
import {KontaktniPodatkiEnum} from '../../../../../assets/js/Enum/KontaktniPodatkiEnum.js'
import {StringConverter} from '../../../../../assets/js/globalne_funkcije/SplosneGlobalneFunkcije/StringConverter'
import OrderButton from '../../../../UIComponents/OrderButton.vue'
import OrderExistsInfo from '../../../../UIComponents/OrderExistsInfo.vue'
export default {
  name: 'T2Paket',
  mixins: [StringConverter],
  emits: ['orderConfirmed'],
  data () {
    return {
      kontaktniPodatki: null,
      izbranaUgodnostPaketNova: {},
      izbranaHitrostPaketNova: {},
      prepovedanPrikazZneska: '0,00',
      obstojIzbireHitrostiPriTrznihPaketih: {},
      obstojIzbireUgodnostiPriTrznihPaketih: {},
      spremniText: ''
    }
  },
  props: {
    seznamPaketov: Array,
    infoPripisObPaketu: null,
    izbranaHitrostPaket: null,
    izbranaUgodnostPaket: null,
    seznamIzbranaUgodnostPaket: null,
    tabKey: null,
    infoIzbranegaPrikljucka: null,
    naroceneStoritve: null
  },
  computed: {
    narociloVTeku () {
      return Array.isArray(this.naroceneStoritve) && this.naroceneStoritve.length > 0
    }
  },
  watch: {
    seznamPaketov () {
      this.PreveriIzbireHitrostiInUgodnostiVPaketu()
    },
    izbranaHitrostPaket: function (val) {
      this.izbranaHitrostPaketNova = {}
      for (const index in this.izbranaHitrostPaket) {
        Vue.set(this.izbranaHitrostPaketNova, index, JSON.parse(JSON.stringify(this.izbranaHitrostPaket[index])))
      }
    },
    izbranaUgodnostPaket: function (val) {
      this.izbranaUgodnostPaketNova = {}
      for (const index in this.izbranaUgodnostPaket) {
        Vue.set(this.izbranaUgodnostPaketNova, index, JSON.parse(JSON.stringify(this.izbranaUgodnostPaket[index])))
      }
    }
  },
  components: {
    OrderExistsInfo,
    OrderButton,
    InfoKomponenta,
    [Button.name]: Button,
    [Form.name]: Form,
    [Option.name]: Option,
    [Select.name]: Select,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Col.name]: Col,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [TabPane.name]: TabPane,
    [Tabs.name]: Tabs
  },
  mounted () {
    this.kontaktniPodatki = KontaktniPodatkiEnum
    this.izbranaHitrostPaketNova = {}
    for (const index in this.izbranaHitrostPaket) {
      Vue.set(this.izbranaHitrostPaketNova, index, JSON.parse(JSON.stringify(this.izbranaHitrostPaket[index])))
    }
    for (const index in this.izbranaUgodnostPaket) {
      Vue.set(this.izbranaUgodnostPaketNova, index, JSON.parse(JSON.stringify(this.izbranaUgodnostPaket[index])))
    }
  },
  methods: {
    GetServices (paket) {
      let newServices = []
      let idUgodnost = null
      let idSvi = paket.idStoritevVrstaIzbira
      let sprememnjenaHitrost = false
      let sprememnjenaUgodnost = false
      if (this.izbranaHitrostPaketNova[idSvi] !== this.izbranaHitrostPaket[idSvi]) {
        newServices.push(
          {
            serviceId: this.GetHitrost(this.izbranaHitrostPaketNova[paket.idStoritevVrstaIzbira]).id,
            quantity: 1,
            terminationPointId: Number.parseInt(this.infoIzbranegaPrikljucka.id_prikljucek)
          }
        )
        sprememnjenaHitrost = true
      }
      let idPaketReverse = paket.idStoritevVrstaIzbira.toString().split('').reverse().join('')
      for (const index in this.izbranaUgodnostPaketNova) {
        if (this.izbranaUgodnostPaketNova[index] !== this.izbranaUgodnostPaket[index]) {
          let indexReverse = index.split('').reverse().join('')
          if (indexReverse.substring(0, idPaketReverse.length + 1) === idPaketReverse + '_') {
            idUgodnost = Number.parseInt(index.substring(0, index.indexOf('_')))
            newServices.push(
              {
                serviceId: idUgodnost,
                quantity: this.izbranaUgodnostPaketNova[index] ? 1 : 0,
                terminationPointId: Number.parseInt(this.infoIzbranegaPrikljucka.id_prikljucek)
              }
            )
            sprememnjenaUgodnost = true
          }
        }
      }
      if (sprememnjenaHitrost && sprememnjenaUgodnost) {
        this.spremniText = 'spremeniti nabor storitev v tržnem paketu'
      } else if (sprememnjenaHitrost) {
        this.spremniText = 'vklopiti izbrano internetno hitrost v tržnem paketu'
      } else if (sprememnjenaUgodnost) {
        this.spremniText = 'vklopiti izbrano ugodnost za naročeni tržni paket'
      }
      return newServices
    },
    GetHitrost (hitrost) {
      let id = Number(hitrost.split('_')[0])
      let naziv = ''
      this.seznamPaketov.forEach(paket => {
        paket.hitrosti.forEach(hitrost => {
          if (hitrost.idStoritevVrstaIzbira === id) {
            naziv = hitrost.naziv
          }
        })
      })
      return {id: id, naziv: naziv}
    },
    GetPreracunanaCena (paket) {
      if (this.izbranaHitrostPaketNova[paket.idStoritevVrstaIzbira] !== null &&
        typeof this.izbranaHitrostPaketNova[paket.idStoritevVrstaIzbira] !== 'undefined') {
        let hitrostPaket = this.izbranaHitrostPaketNova[paket.idStoritevVrstaIzbira]
        let idIzbranaHitrostStr = hitrostPaket.substring(0, hitrostPaket.indexOf('_'))
        let cenaHitrost = 0
        for (const index in paket.hitrosti) {
          if (idIzbranaHitrostStr === paket.hitrosti[index].idStoritevVrstaIzbira.toString()) {
            cenaHitrost = paket.hitrosti[index].cena
            break
          }
        }
        return this.PikeVVejice(parseFloat(paket.cena + (cenaHitrost - paket.cena)).toFixed(2))
      }
      return paket.cenaSI
    },
    PreveriIzbireHitrostiInUgodnostiVPaketu () {
      this.obstojIzbireHitrostiPriTrznihPaketih = {}
      this.obstojIzbireUgodnostiPriTrznihPaketih = {}
      for (const index in this.seznamPaketov) {
        let paket = this.seznamPaketov[index]
        let idSviPaketa = paket.idStoritevVrstaIzbira
        Vue.set(this.obstojIzbireHitrostiPriTrznihPaketih, idSviPaketa, false)
        Vue.set(this.obstojIzbireUgodnostiPriTrznihPaketih, idSviPaketa, false)
        // preverjanje moznosti izbire hitrosti v paketu
        if (typeof paket.hitrosti !== 'undefined' && paket.hitrosti !== null && paket.hitrosti.length > 0 && paket.dovoljenaIzbira) {
          for (const indexHitrost in paket.hitrosti) {
            let hitrost = paket.hitrosti[indexHitrost]
            if (hitrost.prikazServisne !== 0) {
              this.obstojIzbireHitrostiPriTrznihPaketih[idSviPaketa] = true
              break
            }
          }
        }
        // preverjanje moznosti izbire vezave v paketu
        if (typeof paket.ugodnosti !== 'undefined' && paket.ugodnosti !== null && paket.ugodnosti.length > 0 && paket.dovoljenaIzbira === 1) {
          this.obstojIzbireUgodnostiPriTrznihPaketih[paket.idStoritevVrstaIzbira] = true
        }
      }
    },
    PrikazPogodbe (paket) {
      let idHitrost = null
      if (this.izbranaHitrostPaketNova[paket.idStoritevVrstaIzbira] !== null) {
        let hitrostPaket = this.izbranaHitrostPaketNova[paket.idStoritevVrstaIzbira]
        idHitrost = hitrostPaket.substring(0, hitrostPaket.indexOf('_'))
      } else {
        idHitrost = paket.hitrosti[0].idStoritevVrstaIzbira
      }
      let idUgodnost = null
      let idPaketReverse = paket.idStoritevVrstaIzbira.toString().split('').reverse().join('')
      for (const index in this.izbranaUgodnostPaketNova) {
        // iskanje oznacene ugodnosti v paketu
        if (this.izbranaUgodnostPaketNova[index] === true && this.izbranaUgodnostPaket[index] === false) {
          let indexReverse = index.split('').reverse().join('')
          if (indexReverse.substring(0, idPaketReverse.length + 1) === idPaketReverse + '_') {
            idUgodnost = index.substring(0, index.indexOf('_'))
          }
        }
      }
      this.$emit('PrikaziPotrditvenoOknoZaNarociloStoritve', paket, idHitrost, idUgodnost)
    },
    PosodobiPotencialnoNarocilo (idPaket, idHitrost) {
      let idTrenutnoNarocenPaket = null
      for (const index in this.izbranaHitrostPaket) {
        if (this.izbranaHitrostPaket[index] !== null) {
          idTrenutnoNarocenPaket = index
        }
      }
      // izbrana hitrost iz drugega paketa => ponastavi prvi paket
      if (idTrenutnoNarocenPaket !== null) {
        if (idTrenutnoNarocenPaket.toString() !== idPaket.toString()) { // izbrana hitrost izven narocenega paketa
          for (const index in this.izbranaHitrostPaket) {
            if (index.toString() !== idTrenutnoNarocenPaket.toString() && index.toString() !== idPaket.toString()) {
              this.izbranaHitrostPaketNova[index] = null
            }
          }
          this.izbranaHitrostPaketNova[idTrenutnoNarocenPaket] = this.izbranaHitrostPaket[idTrenutnoNarocenPaket]
        } else { // izbrana hitrost znotraj narocenega paketa
          for (const index in this.izbranaHitrostPaket) {
            if (idTrenutnoNarocenPaket.toString() !== index.toString()) {
              this.izbranaHitrostPaketNova[index] = null
            }
          }
        }
      } else { // od prej ni izbran noben paket
        for (const index in this.izbranaHitrostPaketNova) {
          if (idPaket.toString() !== index.toString()) {
            this.izbranaHitrostPaketNova[index] = null
          }
        }
      }
      this.izbranaHitrostPaketNova[idPaket] = idHitrost + '_' + idPaket
      this.OdstraniIzbraneUgodnostiDrugihPaketov(idPaket)
    },
    OdstraniIzbraneUgodnostiDrugihPaketov (idPaket) {
      let idPaketReverse = idPaket.toString().split('').reverse().join('')
      for (const index in this.izbranaUgodnostPaketNova) {
        let indexReverse = index.split('').reverse().join('')
        if (indexReverse.substring(0, idPaketReverse.length + 1) !== idPaketReverse + '_' &&
          this.izbranaUgodnostPaketNova[index] === true) {
          Vue.set(this.izbranaUgodnostPaketNova, index, false)
        }
      }
    },
    OdstraniOstaleIzbireUgodnosti (izbranaKombinacija) {
      for (const index in this.izbranaUgodnostPaketNova) {
        if (index.toString() !== izbranaKombinacija.toString() &&
          this.izbranaUgodnostPaketNova[index] === true) {
          Vue.set(this.izbranaUgodnostPaketNova, index, false)
        }
      }
    },
    PrikaziObvestiloNemogocaSpremembaUgodnosti (index) {
      this.izbranaUgodnostPaketNova[index] = true
      let paramObvestilo = {}
      paramObvestilo.message =
      'Oprostite, preklic vezave ni možno opraviti na portalu Moj T-2. Prosimo, pokličite nas na ' +
      this.kontaktniPodatki.T2_SUPPORT_TEL_ST
      this.ShowWarningMessage(paramObvestilo)
    },
    StaSeznamUgodnostiEnaka () {
      if (this.izbranaUgodnostPaketNova.length !== this.izbranaUgodnostPaket.length) {
        return false
      }
      for (const index in this.izbranaUgodnostPaket) {
        if (typeof this.izbranaUgodnostPaket[index] === 'undefined' ||
        this.izbranaUgodnostPaket[index] !== this.izbranaUgodnostPaketNova[index]) {
          return false
        }
      }
      return true
    }
  }
}
</script>

<style scoped src="../../../../../../static/css/Naroci/NarociTrzniPaketi/T2Paket.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Naroci/NarociTrzniPaketi/T2Paket.vue